// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"540c72a7","498":"4e6eb084","513":"7ea511c2"}[chunkId] + ".chunk.js";
};